module.exports = __webpack_public_path__ + "img/Heart.svg";